<div *ngIf="!openConfirmation">
  <div class="employer-paymentaccount-list">
    <div class="container m--full-bleed">
      <!-- ROW: BANK ACCOUNTS -->
      <div class="row m--full-bleed mb-3">
        <div class="col-12">
          <mat-card tabindex="0"class="card-container">
            <mat-card-header>
              <mat-card-title>
                <h2 class="mat-card-title mb-0">Bank Accounts
                  <a target="_blank" href="/assets/help/How To Add Bank Account.pdf" class="dib ml-1">
                    <span class="fa fa-question-circle fa-sm-blue" matTooltip="HOW TO ADD A BANK ACCOUNT" 
                      aria-label="How to Add a Bank Account"
                      matTooltipClass="tooltip-md">
                    </span>
                  </a>
                </h2>

                <div class="header-cta">
                  <a (click)="addNewPaymentAccount()" class="ts-s c-blue1">
                    Add
                    <span class="fa fa-plus-circle fa-md-blue" matTooltip="ADD NEW BANK ACCOUNT"
                      matTooltipClass="tooltip-md">
                    </span>
                  </a>
                </div>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content tabindex="0"
              [ngStyle]="{'max-height' : showAddEditPaymentAccount ? '19vh' : '50vh', 'overflow': 'auto'}">
              <table tabindex="0" class="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th *ngIf="!isMobile">Type</th>
                    <th *ngIf="!isMobile">Account</th>
                    <th *ngIf="!isMobile">Status</th>
                    <th># of Payments</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="isLoadingAccounts">
                    <span><i class="fa fa-refresh fa-spin fa-2x fa-fw mt-4"></i></span>
                  </tr>
                  <tr *ngFor="let account of paymentaccounts">
                    <td>{{account.bankName}}</td>
                    <td *ngIf="!isMobile">{{account.accountTypeName}}</td>
                    <td *ngIf="!isMobile">{{account.accountNumberMasked}}</td>
                    <td *ngIf="!isMobile"
                      [ngClass]="{'paymentAccountHold' : account.holdStatus || account.prenoteStatus === prenoteEnum.Failed}"
                      matTooltip="{{account.holdStatus ? 'This account is currently on hold and not eligible for ACH debit.' :
                                                account.prenoteStatus === prenoteEnum.Prenote ? 'A prenote (or prenotification) is a zero dollar test to validate the
                                                                                 employer bank account information. Prenotes are sent and verified before
                                                                                 direct deposit payroll can be processed.' :
                                                account.prenoteStatus === prenoteEnum.Failed ? 'Bank Account has FAILED to become active.  Please contact us for more information':
                                                                         'Bank Account is Active'}}"
                      matTooltipClass="tooltip-md">
                      {{account.holdStatus ? 'On Hold' :
                      account.prenoteStatus === prenoteEnum.Prenote ? 'Prenote' :
                      account.prenoteStatus === prenoteEnum.Failed ? 'Failed' : 'Active' }}
                    </td>
                    <td>
                      <b (click)="goToLanding()" class="ts-l c-blue1" matTooltip="VIEW SCHEDULED PAYMENTS"
                        matTooltipClass="tooltip-md">{{account.numberOfScheduledPayments}}</b>
                    </td>
                    <td *ngIf="!account.holdStatus">
                      <div class="flex-ico-btns">
                        <i (click)="editaccount(account)" class="fa fa-pencil-square-o fa-md-blue"
                          matTooltip="EDIT ACCOUNT" matTooltipClass="tooltip-md"></i>
                        <i (click)="deleteaccount(account)" class="fa fa-trash-o fa-md-blue" matTooltip="DELETE ACCOUNT"
                          matTooltipClass="tooltip-md"></i>
                        <i (click)="goToPayments(account)" class="fa fa-money fa-md-blue" matTooltip="ADD NEW PAYMENT"
                          matTooltipClass="tooltip-md"></i>
                      </div>
                    </td>
                    <td *ngIf="account.holdStatus">
                    </td>
                  </tr>
                </tbody>
              </table>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
      <!-- ROW: ADD / EDIT PAYMENT -->


      <epay-common-new-pay-account *ngIf="showAddEditPaymentAccount" [editaccount]="accountForEdit"
        [baseurl]="baseurl" [routingHelpImage]="routingHelpImage"
        (closeAccountPanel)="togglePaymentAccountPanel($event)"></epay-common-new-pay-account>

    </div><!-- /.container.m--full-bleed -->
  </div>
</div>

<epay-lib-common-confirmation *ngIf="openConfirmation" [sender]="confirmationSender"
  [confirmationTitle]="confirmationTitle" [confirmationMessage]="confirmationMessage"
  [confirmationNumber]="confirmationNumber" [goToPrimary]="goToPrimary" [goToPrimaryUrl]="goToPrimaryUrl"
  [goToSecondary]="goToSecondary" [goToSecondaryUrl]="goToSecondaryUrl"
  (confirmationEmitter)="hideConfirmationPage($event)">
</epay-lib-common-confirmation>

